export default __webpack_public_path__ + "static/media/logo-small.48d3e3ad.svg";